import React, { useEffect, useState } from "react";
import { Topbar } from "@components";
import { PRIVATE_ROUTE, PUBLIC_ROUTE } from "@router/route.constants";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import {
  Amount,
  Date,
  EmptyBox,
  EmptyHistoryContainer,
  HistoryBox,
  HistoryContainer,
  LeftSection,
  Link,
  LinkContainer,
  Loader,
  NoResultText,
  RootContainer,
  View,
  CopyContainer,
  ShareButton,
  TNCBtn,
} from "./ShareHistory.style";
import { Alert } from "@components";
import { getFormattedNumber, formatShareName } from "@utils";
import moment from "moment";
import { EmptyShareFilled, PinkCopyIcon, GrayHistoryIcon } from "@assets";
import { api } from '@api';
import { useTranslation } from "react-i18next";
import { Spin, message } from "antd";
import { SHARE_ID_LK } from "@constants";
import copy from "copy-to-clipboard";
import { useDispatch } from "react-redux";
import { openAlert } from "@redux/app/appSlice";
import ShareModal from './ShareModal/ShareModal';

const dateFormat = "MMM DD, YYYY hh:mm:ss A";

const ShareHistory = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [shareHistory, setShareHistory] = useState([]);
  const [termsAndConditions, setTermsAndCondition] = useState({});
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();
  const [link, setLink] = useState('');
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  // const shareType = state?.share_type?.split('_')[1];

  useEffect(() => {
    if (!state) {
      return;
    }
    getShareHistory();
    getTermsAndConditons();
    getLink();

    // eslint-disable-next-line
  }, []);


  const getLink = () => {
    const domain = window.location.hostname;
    let link = `${domain}/${PUBLIC_ROUTE.SHARE_REGISTER}?${SHARE_ID_LK}=${state?.share_id}`
    setLink(link);
  }

  const copyText = () => {
    try {
      copy(link);
      showAlert({
        message: t("common.copied"),
      });
    } catch (error) {
      //create input or text area
      const input = document.createElement("input");
      input.setAttribute("value", link);
      document.body.appendChild(input);
      input.select();
      const result = document.execCommand("copy");
      document.body.removeChild(input);
      if (result) {
        showAlert({
          message: t("common.copied"),
        });
      } else {
        showAlert({
          message: "Failed to copy to clipboard.",
          isError: true,
        });
      }
    }
  };

  const showAlert = (data) => {
    dispatch(openAlert(data));
  };

  const getShareHistory = () => {
    setLoading(true);
    api
      .getShareHistory({
        share_id: state?.share_id
      })
      .then(({ share_history }) => {
        setLoading(false);
        setShareHistory(share_history);
      })
      .catch((errorMsg) => {
        setLoading(false);
        message.error(errorMsg)
      });
  };

  const getTermsAndConditons = () => {
    api
      .getShareTNC({ type: state?.share_type })
      .then(({ tnc }) => {
        setTermsAndCondition(tnc)
      })
      .catch((errorMsg) => {
        message.error(errorMsg);
      });
  }

  const goBack = () => {
    navigate(`/${PRIVATE_ROUTE.SHARE_SUMMARY}`);
  };

  const goToShareTerms = () => {
    navigate(`/${PRIVATE_ROUTE.SHARE_TERMS}`, {
      state: {
        ...state,
        termsAndConditions,
      }
    });
  }

  const EmptyCard = () => (
    <EmptyBox>
      <EmptyShareFilled />
      <NoResultText>{t("share.emptyHistoryMessage")}</NoResultText>
    </EmptyBox>
  );

  const CopyLinkBox = () => (
    <LinkContainer>
      <CopyContainer>
        <PinkCopyIcon onClick={copyText} />
        <Link> {`${link.slice(0, 20)}...`} </Link>
      </CopyContainer>
      <ShareButton
        type="secondary"
        onClick={() => setOpen(true)}
      > {t("profile.share")} </ShareButton>
    </LinkContainer>
  )

  if (!state) {
    return <Navigate to={`/${PUBLIC_ROUTE.HOME}/${PUBLIC_ROUTE.PROFILE}`} />
  }

  return (
    <>
      <Topbar
        title={`${formatShareName(state.share_type)} ${t("share.history")}`}
        goBack={goBack}
      />
      <RootContainer>
        <CopyLinkBox />

        {loading
          ? (
            <Loader>
              <Spin />
            </Loader>
          )
          : shareHistory.length === 0
            ? (
              <EmptyHistoryContainer>
                <EmptyCard />
                <Alert />
              </EmptyHistoryContainer>)

            : (
              <>
                <HistoryContainer>
                  {shareHistory.map((item, index) => (
                    <HistoryBox key={index}>
                      <GrayHistoryIcon />
                      <LeftSection>
                        <Date> {moment.unix(item.created_at).format(dateFormat)} </Date>
                        <View> {t("share.collected")} <span> {item.collected_count} {t("share.views")} </span> </View>
                      </LeftSection>
                      <Amount>{`${getFormattedNumber(
                        item.collected_amount
                      )}`}</Amount>
                    </HistoryBox>
                  ))}
                </HistoryContainer>
                <Alert />
              </>
            )}

        <TNCBtn
          type="primary"
          onClick={goToShareTerms}
        > {t("common.termsAndConditions")} </TNCBtn>
        
        <ShareModal
          link={link}
          open={open}
          handleClose={() => setOpen(false)}
          copy={copyText}
        />
      </RootContainer>

    </>
  );
};

export default ShareHistory;
